export default __webpack_public_path__ + "media/images/dashboard_icons/star-a93c10fc0b55867508e664c476b419ab.svg";